import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

import { Environment } from '@src/environments/environment'

export interface Me {
  first_name: string
  last_name: string
  email: string
  count_member_of_structure: number
  count_member_request_pending: number
  /** Au moins une structure rattachée peut déposer une demande de financement. */
  has_employer_structure: boolean
  /** Activité d'employeur présente ou passée : des demandes ou versements à consulter. */
  has_employer_history: boolean
  /** Au moins une structure rattachée porte un organisme de formation. */
  has_training_organization: boolean
}

@Injectable({
  providedIn: 'root',
})
export class MeService {
  private apiPath: string = Environment.API_PATH

  constructor(private http: HttpClient) { }

  getMe(): Observable<Me> {
    return this.http.get<Me>(`${this.apiPath}/v1/me`).pipe(
      catchError(() => {
        return throwError(() => 'Impossible de charger les informations de l\'utilisateur')
      })
    )
  }
}
